exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.des[data-v-33c57d92]{font-size:18px;color:#303133;margin-bottom:20px\n}\n.dialog-content[data-v-33c57d92]{max-height:300px;overflow:auto\n}\n", "", {"version":3,"sources":["D:/地质云项目/DZYWebUI/src/views/document/components/AuditProcess.vue"],"names":[],"mappings":";AACA,sBAAsB,eAAe,cAAc,kBAAkB;CACpE;AACD,iCAAiC,iBAAiB,aAAa;CAC9D","file":"AuditProcess.vue","sourcesContent":["\n.des[data-v-33c57d92]{font-size:18px;color:#303133;margin-bottom:20px\n}\n.dialog-content[data-v-33c57d92]{max-height:300px;overflow:auto\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-33c57d92","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/document/components/AuditProcess.vue
// module id = 7bmH
// module chunks = 78